// Copyright (c) StrangeBee 2023

import { useState } from 'react';

interface UseDebounceInterface {
    onClear?: (...args: any[]) => any;
    onTimeout: (...args: any[]) => any;
    timeoutDelay: number;
}

interface UseDebounceReturn {
    debounce: ({ onClear, onTimeout, timeoutDelay }: UseDebounceInterface) => void;
}

const useDebounce = (): UseDebounceReturn => {
    const [timeoutId, setTimeoutId] = useState<number>();

    return {
        debounce: ({ onClear, onTimeout, timeoutDelay = 1000 }: UseDebounceInterface): void => {
            if (timeoutId) {
                onClear?.();
                clearTimeout(timeoutId);
            }

            setTimeoutId(window.setTimeout(onTimeout, timeoutDelay));
        },
    };
};

export default useDebounce;
